import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataConnectionRoutingModule } from './data-connection-routing.module';
import { DataConnectionComponent } from './data-connection.component';
import { ConfigureConnectionComponent } from './components/configure-connection/configure-connection.component';

import { TextPrettyPipe } from 'src/app/pipes/text-pretty.pipe';
import { FormBuilderComponent } from 'src/app/components/form-buider/form-buider.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';

@NgModule({
  declarations: [DataConnectionComponent, ConfigureConnectionComponent],
  imports: [
    CommonModule,
    MaterialModule,
    DataConnectionRoutingModule,
    TextPrettyPipe,
    FormBuilderComponent,
    ReactiveFormsModule,
    FormsModule,
    NamingSizePipe,
  ],
  exports: [DataConnectionComponent],
})
export class DataConnectionModule {}
